let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2exA8")).then(() => parcelRequire('iiIdc'));